module.exports = __webpack_public_path__ + "portal/assets/img/logo.a0c50028.svg";